class ResponsiveImage extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['img']
  }

  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.els.img.element.complete) {
      this.blurred = false
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.img.element,
      'load',
      this.onImageLoad.bind(this),
    )
  }

  onImageLoad () {
    this.blurred = false
  }

  get blurred () {
    return this.dataset.blurred === 'true'
  }

  set blurred (val) {
    this.dataset.blurred = val.toString()
  }
}

if (!customElements.get('responsive-image')) {
  customElements.define('responsive-image', ResponsiveImage)
}
